import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class IncompleteIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4 7v2h8V7H4z"/></svg>
        )
    }
}

export default withCssClassName(IncompleteIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/incomplete-icon.js